export const defaultHomeContent = {
  trust: { isActive: true, items: [
    { title: 'Authentic wood', detail: 'Certificate included' }, { title: 'Legally sourced', detail: 'Licensed supply' },
    { title: 'Hand-finished', detail: 'Mysuru artisans' }, { title: 'Pan-India delivery', detail: 'Carefully packed' },
  ] },
  collections: { isActive: true, eyebrow: 'Find your ritual', title: 'Shop by collection', items: [
    { name: 'Carved idols', detail: 'Sacred forms for home and travel', image: '/assets/ganesha_idol.jpg', link: '/shop?category=car-dashboard-idols', featured: true },
    { name: 'Japa malas', detail: '108 beads for daily practice', image: '/assets/sandalwood_mala.jpg', link: '/shop?category=malas' },
    { name: 'Bracelets', detail: 'Natural fragrance, close at hand', image: '/assets/sandalwood_bracelet.jpg', link: '/shop?category=bracelets' },
    { name: 'Incense', detail: 'Pure chandan for calm spaces', image: '/assets/sandalwood_agarbatti.jpg', link: '/shop?category=agarbatti' },
    { name: 'Meaningful gifts', detail: 'Thoughtful sandalwood keepsakes', image: '/assets/sandalwood_keychain.jpg', link: '/shop?category=keychains' },
  ] },
  favourites: { isActive: true, eyebrow: 'Most loved', title: 'Customer favourites', linkText: 'Shop favourites', link: '/shop?sort=rating', limit: 4 },
  story: { isActive: true, eyebrow: 'From source to sacred object', title: 'Purity you can trace. Craft you can feel.', description: 'Our sandalwood is sourced through licensed channels and shaped by skilled craftspeople in Mysuru. Each finished piece keeps the material’s natural grain, fragrance, and individual character.', image: '/assets/purity_banner.jpg', bullets: ['Licensed sandalwood supply', 'Traditional hand-finishing', 'Authenticity documentation', 'Protective, gift-ready packing'], primaryText: 'Our authenticity promise', primaryLink: '/authenticity', secondaryText: 'Meet our heritage', secondaryLink: '/about' },
  standard: { isActive: true, eyebrow: 'The Chandana standard', title: 'Made carefully, delivered confidently', items: [
    { number: '01', title: 'Choose with clarity', detail: 'Detailed materials, dimensions, variants, and stock on every product.' },
    { number: '02', title: 'Packed with care', detail: 'Protective presentation designed for safe delivery and meaningful gifting.' },
    { number: '03', title: 'Supported after arrival', detail: 'Order tracking, invoices, and a straightforward seven-day return window.' },
  ] },
  journal: { isActive: true, eyebrow: 'Knowledge from the source', title: 'The sandalwood journal', linkText: 'View all articles' },
  guidance: { isActive: true, eyebrow: 'Buy with confidence', title: 'A little guidance goes a long way.', description: 'Learn what genuine sandalwood looks like, how to preserve it, or ask us about a product before ordering.', items: [
    { title: 'Verify authenticity', detail: 'Understand our sourcing and documentation.', link: '/authenticity' },
    { title: 'Care for sandalwood', detail: 'Keep its natural grain and aroma at their best.', link: '/care-guide' },
    { title: 'Ask a specialist', detail: 'Get help choosing the right piece or gift.', link: '/contact' },
  ] },
  cta: { isActive: true, eyebrow: 'Crafted in Mysuru', title: 'Bring home the natural fragrance of sandalwood.', description: 'Explore authentic pieces for worship, wellbeing, daily wear, and gifting.', buttonText: 'Shop the collection', buttonLink: '/shop' },
};

export const defaultHomeBanners = [
  {
    _id: 'banner-1',
    image: '/assets/hero_slide_ganesha.jpg',
    title: 'Authentic Sandalwood Products, Crafted with Tradition',
    subtitle: 'Experience the natural sacred fragrance and spiritual energy of pure Mysore sandalwood.',
    buttonText: 'Shop Collection',
    link: '/shop'
  },
  {
    _id: 'banner-2',
    image: '/assets/hero_slide_shiva.jpg',
    title: 'Sacred Temple Idols & Divine Sanctum Deities',
    subtitle: 'Exquisitely hand-carved pure sandalwood sacred statues bringing auspicious harmony and peace.',
    buttonText: 'Explore Idols',
    link: '/shop?category=idols'
  },
  {
    _id: 'banner-3',
    image: '/assets/hero_slide_workshop.jpg',
    title: 'Preserving Centuries of Mysuru Craftsmanship',
    subtitle: 'Hand-carved by master artisans using 100% government-certified genuine Mysore sandalwood timber.',
    buttonText: 'Our Heritage',
    link: '/about'
  },
  {
    _id: 'banner-4',
    image: '/assets/hero_slide_vedic.jpg',
    title: 'Sacred Japa Malas & Ancient Vedic Wisdom',
    subtitle: '108-bead natural fragrant chanting malas and temple incense for daily meditation and spiritual focus.',
    buttonText: 'Discover Malas',
    link: '/shop?category=malas'
  }
];

export const defaultHomeBanner = defaultHomeBanners[0];

export const mergeHomeContent = (content = {}) => Object.fromEntries(
  Object.entries(defaultHomeContent).map(([key, value]) => [key, { ...value, ...(content[key] || {}) }])
);

